import { useDispatch, useSelector } from "react-redux";
import { requestReadMessage } from "../store/actionCreators/messages";
import {
  casinoTournamentsRequestWihoutDelay,
  casinoTournamentsUpdateWihoutDelay,
  selectCasinoTournament,
} from "../store/actionCreators/casinoTournament";
import { closeAllDialogs, closeDialog, openDialog } from "../store/actionCreators/dialogManager";
import {
  requestTournamentGameUrl,
  resetTournamentGameUrl,
} from "../store/actionCreators/tournamentGameUrl";
import {
  resetToggleJackpotGameFromHost,
  setToggleJackpotGameFromHost,
} from "../store/actionCreators/toggleJackpotGameFromHost";
import { setTab } from "../store/actionCreators/tab";
import { resetTournamentPlayers } from "../store/actionCreators/tournamentCasinoPlayers";
import { setActualLanguage } from "../store/actionCreators/language";
import { getAccountBalanceRequestFromHost } from "../store/actionCreators/getAccountBalance";
import {
  loginSetQueryParams,
  logoutSetQueryParams,
} from "../store/actionCreators/queryParams";
import { useCallback } from "react";
import { resetCashGameUrl } from "../store/actionCreators/cashGameUrl";
import { useTranslation } from "react-i18next";
import { getCasinoTournament } from "../store/selectors";

export const useCustomFunctions = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const tournament = useSelector(getCasinoTournament);


  const handleLogout = useCallback(() => {
    localStorage.removeItem("selectedCurrency");
  }, []);

  const handleReadMessage = useCallback(
    (messageId) => {
      if (messageId) {
        dispatch(requestReadMessage(messageId));
      }
    },
    [dispatch]
  );

  const handleOpenDialogByHostInitiative = useCallback(
    ({ dialogType, game, tournamentId }) => {
      if (dialogType === "tournamentRegister") {
        if (game) {
          dispatch(selectCasinoTournament(game));
          dispatch(
            openDialog({
              tournament: game,
              dialogType: "tournamentRegister",
            })
          );
        } else if (tournamentId) {
          dispatch(
            casinoTournamentsRequestWihoutDelay({
              openRegisterPopup: { tournamentId },
            })
          );
        }
      } else {
        dispatch(openDialog({ dialogType }));
      }
    },
    [dispatch]
  );

  const handleCloseDialogByHostInitiative = useCallback(
    ({ dialogType }) => {
      if (dialogType) {
        dispatch(closeDialog(dialogType));
      }
    },
    [dispatch]
  );

  const handleOpenGame = useCallback(
    (game) => {
      if (game) {
        dispatch(requestTournamentGameUrl(game));
        dispatch(selectCasinoTournament(game));
      }
    },
    [dispatch]
  );

  const handleOpenSipinAndGo = useCallback(
    ({ tournamentId }) => {
      if (tournamentId) {
        dispatch(
          setToggleJackpotGameFromHost({
            toggle: true,
            id: tournamentId,
          })
        );
        dispatch(setTab("jackpot"));
      }
    },
    [dispatch]
  );

  const handleCloseGame = useCallback(() => {
    dispatch(resetTournamentGameUrl());
    dispatch(casinoTournamentRegisterReset());
    dispatch(resetTournamentPlayers());
    dispatch(resetToggleJackpotGameFromHost(false));
    dispatch(closeAllDialogs());
  }, [dispatch]);

  const handleLanguageChange = useCallback(
    (language) => {
      if (language) {
        dispatch(setActualLanguage(language));
        i18n.changeLanguage(language);
      }
    },
    [dispatch]
  );

  const handleTriggerBalance = useCallback(() => {
    dispatch(getAccountBalanceRequestFromHost());
  }, [dispatch]);

  const handleUpdateTournaments = useCallback(() => {
    dispatch(casinoTournamentsUpdateWihoutDelay());
  }, [dispatch]);

  const handleGDLoginAction = useCallback(
    (payload) => {
      dispatch(loginSetQueryParams(payload));
    },
    [dispatch]
  );

  const handleGDLogoutAction = useCallback(() => {
    dispatch(logoutSetQueryParams());
  }, [dispatch]);

  const OnVeloxForceCloseGame = useCallback(() => {
    dispatch(
      openDialog({
        dialogType: "veloxForceCloseGame",
        tournamentId: tournament.tournamentId,
      })
    );
  }, [tournament]);

  const handleCasinoCloseMessage = useCallback(
    (message) => {
      const casinoCloseMessages = [
        'close',
        'closeGame',
        'notifyCloseContainer',
        'GAME_MODE:LOBBY',
      ];
      if (casinoCloseMessages.includes(message)) {
        ['closeGame'].includes(message)
          ? dispatch(requestTournamentGameUrl(tournament))
          : OnVeloxForceCloseGame();
      }
    },
    [dispatch]
  );

  const handleGameStatusMessage = useCallback(
    (status) => {
      if (status === 'closed') {
        OnVeloxForceCloseGame();
      }
    },
    []
  );

  const handleCloseGameBox = useCallback(() => {
    dispatch(resetCashGameUrl());
  }, [dispatch]);

  const handleResetState = useCallback((cb) => {
    if (cb) {
      cb();
    }
  }, []);

  return {
    handleLogout,
    handleReadMessage,
    handleOpenDialogByHostInitiative,
    handleCloseDialogByHostInitiative,
    handleOpenGame,
    handleOpenSipinAndGo,
    handleCloseGame,
    handleLanguageChange,
    handleTriggerBalance,
    handleUpdateTournaments,
    handleGDLoginAction,
    handleGDLogoutAction,
    handleCasinoCloseMessage,
    handleGameStatusMessage,
    handleCloseGameBox,
    handleResetState,
    OnVeloxForceCloseGame,
  };
};
